
  export default {
    name: 'ThemeStoresIndex',
    methods: {
      detectOS() {
        if (typeof navigator === 'undefined') return 'Server'

        const ua = navigator.userAgent

        if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS'
        if (/Android/i.test(ua)) return 'Android'
        return 'Other'
      }
    }
  }
